export default __webpack_public_path__ + "static/media/ri.478725d4.png";